<div class="main-container">
  <div class="columns is-centered">
    <div class="column is-9">
      <app-stepper [steps]="(stepState$ | async)?.steps"></app-stepper>
    </div>
  </div>
  <main class="columns">
    <div *ngIf="(stepState$ | async)?.activeStep === 0" class="column">
      <app-re-route-split-step
        [pnrInfo]="pnrInfo"
        [selectedPassengers]="selectedPassengers"
        (splitIsDone)="callAditionalInfoStep()"
      ></app-re-route-split-step>
    </div>

    <div *ngIf="(stepState$ | async)?.activeStep === 1" class="column">
      <app-passenger-form-re-route
        [passengersInfo]="(pnrInfo$ | async)?.passengers"
        *ngIf="(isAirline$ | async) && (stepState$ | async).activeStep === 1"
      ></app-passenger-form-re-route>
    </div>

    <div *ngIf="(stepState$ | async)?.activeStep === 2" class="column">
      <app-alert *ngIf="isError" [type]="alertType.Error" class="alert-error">
        <span class="weight-medium" title>
          {{ 'shared.operation-failed' | translate }}
        </span>
        <div description>
          {{ _error$.actionsObserver._value?.error?.message | translate }}
        </div>
      </app-alert>

      <app-segments
        *ngIf="pnrInfo"
        [segments]="pnrInfo?.itinerary?.segments"
        [endorsement]="pnrInfo?.endorsement"
        [isReIssueFlow]="pnrInfo?.isReIssueFlow"
        [isTicketOpen]="pnrInfo?.isOpen"
        [baggageAllowance]="pnrInfo?.baggageAllowance"
        [showSeatMap]="false"
      ></app-segments>

      <div class="v-separator"></div>

      <div class="button-container">
        <app-input-submit
          *ngIf="!isError"
          inputText="{{ 'voluntary-change.make-change' | translate }}"
          [isLeft]="false"
          [isFullWidth]="true"
          type="submit"
          (clickButton)="submit()"
        ></app-input-submit>

        <app-input-submit
          *ngIf="isError"
          inputText="{{ 'cancellation-info.back-itinerary' | translate }}"
          [isLeft]="false"
          [isFullWidth]="true"
          type="submit"
          (clickButton)="backItinerary()"
        ></app-input-submit>
      </div>
    </div>

    <div *ngIf="(stepState$ | async)?.activeStep === 3" class="column">
      <div class="v-separator"></div>

      <app-alert [type]="alertType.Success">
        <span class="weight-medium" title>
          {{ 'shared.successful-operation' | translate }}
        </span>
        <div description class="sizeForNoGoSegment">
          <h1>{{ 're-route.success-descriptionNoGo' | translate }}</h1>
        </div>
        <div description>
          {{ 're-route.success' | translate }}
        </div>
      </app-alert>

      <div class="v-separator"></div>

      <div class="button-container">
        <div class="mr-2r">
          <app-remarks [isMarginTop]="false"></app-remarks>
        </div>

        <app-input-submit
          inputText="{{ 'cancellation-info.back-itinerary' | translate }}"
          [isLeft]="false"
          [isFullWidth]="true"
          type="submit"
          (clickButton)="backItineraryRemark()"
        ></app-input-submit>
      </div>
    </div>
  </main>
</div>

<app-modal
  [showCloseFooter]="false"
  [isActive]="showModalRemarks"
  (modalState)="showModalRemarks = false"
  [enableFooter]="true"
>
  <p class="modal-card-title" modal-title>
    {{ 'shared.warning' | translate }}
  </p>
  <div modal-content>
    <p class="has-text-grey mb-2">
      {{ 'remarks.modal-remarks' | translate }}
    </p>
  </div>
</app-modal>
